<!--
 * @Description: 新增机构-基本信息面板组件
 * @Author: wanqian
 * @Date: 2022-03-28 16:58:14
-->
<template>
  <div class="inst-baseinfo-panel-main">
    <el-form class="baseInfoForm" ref="baseInfoForm" :model="baseInfoDO.institution" :rules="rules" 
      label-position="top" label-width="100px">
			<el-row style="margin: 0" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item label="省：" prop="province">
            <el-select size="small" style="width: 100%" v-model="baseInfoDO.institution.province" 
              placeholder="请输入/选择" :disabled="readonly" filterable @change="handleProvinceChange"
              :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'provinceList', srcProvinceList, this))"
					    @visible-change="(visible) => 
                commonUtil.handleListFilterVisibleChange(visible, 'provinceList', srcProvinceList, this)">
              <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.name" />
            </el-select>
        	</el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="市：" prop="city">
            <el-select size="small" style="width: 100%" v-model="baseInfoDO.institution.city" 
              placeholder="请输入/选择" :disabled="readonly" filterable @change="handleCityChange"
              :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'cityList', srcCityList, this))"
					    @visible-change="(visible) => 
                commonUtil.handleListFilterVisibleChange(visible, 'cityList', srcCityList, this)">
              <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="县：" prop="county">
            <el-select size="small" style="width: 100%" v-model="baseInfoDO.institution.county" 
              placeholder="请输入/选择" :disabled="readonly" filterable @change="handleCountyChange"
              :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'countyList', srcCountyList, this))"
					    @visible-change="(visible) => 
                commonUtil.handleListFilterVisibleChange(visible, 'countyList', srcCountyList, this)">
              <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item label="名称：" prop="name">
            <el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.name" :readonly="readonly"
              placeholder="请输入机构名称" minlength="3" @input="inputInstitutionName()">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="机构地址：" prop="addr">
            <el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.addr" :readonly="readonly"
              placeholder="请输入机构地址" oninput="if (value.length > 100) value = value.slice(0, 100)" />
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="保证金（单位：元）：" prop="deposit">
            <el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.deposit" 
              placeholder="请输入保证金" :readonly="readonly" @input="inputDeposit()" />
          </el-form-item>
        </el-col>
      </el-row>
			<el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item label="统一社会信用代码：" prop="bizLicense">
            <el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.bizLicense" :readonly="readonly"
              placeholder="请输入统一社会信用代码" oninput="if (value.length > 30) value = value.slice(0, 30)">
            </el-input>
          </el-form-item>
        </el-col>
				<el-col :span="8" style="text-align: left">
          <el-form-item label="法人代表姓名：" prop="legalPerson">
            <el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.legalPerson" :readonly="readonly"
              placeholder="请输入法人代表姓名" oninput="if (value.length > 20) value = value.slice(0, 20)" />
          </el-form-item>
        </el-col>
				<el-col :span="8" style="text-align: left">
          <el-form-item label="机构编号：" prop="identifier">
            <el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.identifier" 
              placeholder="请输入机构编号" :readonly="readonly" minlength="2" @input="inputInstitutionIdentify()" />
          </el-form-item>
        </el-col>
			</el-row>
			<el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item label="联系人：" prop="contact">
            <el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.contact" :readonly="readonly"
              placeholder="请输入联系人姓名" oninput="if (value.length > 20) value = value.slice(0, 20)" />
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: left">
          <el-form-item label="联系电话：" prop="contactNum">
            <el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.contactNum" 
              placeholder="请输入联系电话" :readonly="readonly" @input="inputContactNum()" 
              oninput="if (value.length > 12) value = value.slice(0, 12)" />
          </el-form-item>
        </el-col>
				<el-col :span="8" style="text-align: left">
          <el-row style="width: 100%" type="flex" justify="start" align="middle">
            <el-form-item label="Logo：" prop="logoPath">
              <el-upload v-if="mode != 'details'" class="logo-uploader" ref="logoUpload" accept="image/jpeg,image/png" 
                action="" :show-file-list="false" :auto-upload="false" :on-change="handleInstLogoChange">
                  <el-image v-if="!logoFile && !baseInfoDO.institution.logoPath" class="img-logo" :src="logoPath" 
                    fit="contain">
                  </el-image>
                  <div v-if="!logoFile && !baseInfoDO.institution.logoPath" 
                    style="color: #409EFF; font-size: 12px; height: 15px; margin-top: -20px">
                    点击上传
                  </div>
                  <div v-else style="width: 64px">
                    <el-image class="img-logo-file" :src="logoPath" fit="contain"></el-image>
                    <span class="text-logo-hover">点击更换</span>
                  </div>
              </el-upload>
              <div v-else :class="baseInfoDO.institution.logoPath && baseInfoDO.institution.logoPath.length 
                ? 'bk-has-logo' : ''">
                <el-image v-if="baseInfoDO.institution.logoPath && baseInfoDO.institution.logoPath.length" 
                  :style="{width: '64px', height: '64px',}" :src="logoPath" :preview-src-list="previewImgList" 
                  fit="contain">
                </el-image>
                <span v-else>无</span>
              </div>
            </el-form-item>
            <div v-if="mode != 'details'" class="tip-logo">
              请上传宽度不小于100像素的图片，图片大小不超过
              <span class="tip-red">5M</span>，支持上传<span class="tip-red">png、jpg、jpeg</span>
            </div>
          </el-row>
        </el-col>
			</el-row>
			<el-row style="margin: 0;" :gutter="50" type="flex" justify="space-between">
				<el-col :span="16" style="text-align: left">
					<el-row :gutter="50" type="flex" justify="space-between">
						<el-col :span="12" style="text-align: left">
							<el-form-item label="客服：" prop="csr">
								<el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.csr" :readonly="readonly"
                  placeholder="请输入客服姓名" oninput="if (value.length > 20) value = value.slice(0, 20)" />
							</el-form-item>
						</el-col>
						<el-col :span="12" style="text-align: left">
							<el-form-item label="客服电话：" prop="csTeleno">
								<el-input size="small" style="width: 100%" v-model.trim="baseInfoDO.institution.csTeleno" 
                  placeholder="请输入客服电话" :readonly="readonly" @input="inputCsTeleno()"
                  oninput="if (value.length > 12) value = value.slice(0, 12)" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="50" type="flex" justify="space-between">
						<el-col :span="24" style="text-align: left">
							<el-form-item style="width: 100%" label="服务说明：" prop="remark">
                <div class="bk-remark">
                  <el-input style="width: 100%" v-model="baseInfoDO.institution.remark" :readonly="readonly"
                    placeholder="请说明本机构服务的范围，例：本机构服务于医院的XX科室/XX楼等" type="textarea" 
                    :rows="2" maxlength="100" />
                  <div class="word-count">
                    {{(baseInfoDO.institution.remark ? baseInfoDO.institution.remark.length : 0) + '/100'}}
                  </div>
                </div>
							</el-form-item>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="营业执照：" prop="picPath">
            <el-upload v-if="mode != 'details'" class="homepage-uploader" ref="homepageUpload" 
              accept="image/jpeg,image/jpg,image/png" action="" :show-file-list="false"
              :auto-upload="false" :on-change="handlePicChange">
              <el-image v-if="!picFile && !baseInfoDO.institution.licensePath" class="img-homepage" :src="picPath" 
                fit="contain">
              </el-image>
              <div v-if="!picFile && !baseInfoDO.institution.licensePath" 
                style="color: #409EFF; font-size: 12px; height: 15px; margin-top: -15px">
                点击上传
              </div>
              <div v-else style="width: 100%; height: 100%;">
                <el-image class="img-homepage-file" :src="picPath" fit="contain"></el-image>
                <span class="upload-branding-hover" style="width: 100%; height: 162px; line-height: 162px;">
                  点击更换图片
                </span>
              </div>
				    </el-upload>
            <div v-else :class="baseInfoDO.institution.licensePath && baseInfoDO.institution.licensePath.length 
              ? 'bk-has-license' : ''">
              <el-image v-if="baseInfoDO.institution.licensePath && baseInfoDO.institution.licensePath.length" 
                :style="{width: '100%', height: '100%',}" 
                :src="picPath" :preview-src-list="previewImgList" fit="contain">
              </el-image>
              <span v-else>无</span>
            </div>
            <div v-if="mode != 'details'" class="tip-licensePath">
              请上传宽度不小于600像素的图片，图片大小不超过
              <span class="tip-red">5M</span>，支持上传<span class="tip-red">png、jpg、jpeg</span>
            </div>
          </el-form-item>
				</el-col>
			</el-row>
      <el-row :gutter="50" style="margin: 0;" type="flex" justify="space-between">
        <el-col :span="24" style="text-align: left">
          <el-form-item style="width: 100%" label="简介：" prop="introduction">
            <div class="bk-introduce">
              <el-input style="width: 100%" v-model="baseInfoDO.institution.introduction" placeholder="请输入简介" 
                :readonly="readonly" type="textarea" :rows="2" maxlength="500" />
              <div class="word-count">
                {{(baseInfoDO.institution.introduction ? baseInfoDO.institution.introduction.length : 0) + '/500'}}
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="50" style="margin: 0;" type="flex" justify="space-between" 
        v-if="!readonly || (readonly && brandingImgs && brandingImgs.length)">
        <el-col :span="24" style="text-align: left">
          <el-form-item style="width: 100%" :label="'关于我们（机构品牌宣传，最多' + maxBrandingImgsCount + '张）：'" 
            prop="brandingImgs">
            <div v-if="readonly" class="bk-details-branding-imgs">
              <div :class="index%3 == 2 ? 'branding-img-item' : 'branding-img-item branding-img-item-space'" 
                v-for="(item, index) in brandingImgs" :key="index">
                <el-image :src="item.img" style="width: 100%; height: 170px; background-color: #EBEEF2;" 
                  :preview-src-list="previewImgList" fit="contain">
                </el-image>
              </div>
            </div>
            <div v-else class="bk-upload-branding">
              <div class="bk-upload-branding-imgs">
                <div :class="index%3 == 2 ? 'branding-img-item' : 'branding-img-item branding-img-item-space'" 
                  v-for="(item, index) in brandingImgs" :key="index">
                  <el-upload class="branding-uploader" ref="brandingUpload" accept="image/jpeg,image/jpg,image/png" 
                    action="" :show-file-list="false" :auto-upload="false" 
                    :on-change="(file, fileList) => {handleBrandChange(index, file, fileList)}">
                    <div style="width: 100%; height: 100%;">
                      <el-image style="width: 100%; height: 100%;" :src="item.img" fit="contain"></el-image>
                      <div class="upload-branding-hover">点击更换图片</div>
                      <div class="bk-delete" @click.stop="handleDeleteBrand(index)">
                        <img style="width: 100%; height: 100%;" :src="require('@/assets/instmng/instlist/img-instmng-delete.png')" 
                          alt="" />
                      </div>
                    </div>
                  </el-upload>
                  <div class="div-branding-error" v-if="item.errorText">{{item.errorText}}</div>
                </div>
                <div v-if="brandingImgs.length < maxBrandingImgsCount" 
                  :class="brandingImgs.length%3 == 2 ? 'branding-img-item' : 'branding-img-item branding-img-item-space'">
                  <el-upload class="branding-uploader" ref="brandingUpload" multiple 
                    accept="image/jpeg,image/jpg,image/png" action="" :show-file-list="false"
                    :file-list="brandingImgs" :auto-upload="false" :on-change="handleAddBrands">
                    <el-image class="img-brandingpage" :src="require('@/assets/common/img-common-chooseimg.png')" 
                      fit="contain">
                    </el-image>
                    <div style="color: #409EFF; font-size: 12px; height: 15px; margin-top: -15px">点击上传</div>
                  </el-upload>
                  <div class="tip">
                    请上传宽度不小于600像素的图片<br/>图片大小不超过<span class="tip-red">5M</span>
                    ，支持上传<span class="tip-red">png、jpg、jpeg</span>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="mode == 'details'" style="margin: 0;" :gutter="50" type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item style="width: 100%;color: #3A7FF3;" label="管理员：">
            <span v-if="baseInfoDO.adminList && baseInfoDO.adminList.length" >
              <span class="mouse-pointer" v-for="(item, index) in baseInfoDO.adminList" :key="item.id"
                @click="handleAdminItemClick(item.id, item.subType)">
                {{index == baseInfoDO.adminList.length-1 ? item.name : (item.name + '，')}}
              </span>
            </span>
            <span v-else >{{'- -'}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="16" style="text-align: left">
          <el-form-item style="width: 100%" label="登陆地址：">
            <div style="display: flex; align-items: center;">
              <span>{{baseInfoDO.landingUrl}}</span>
              <img style="margin-left: 15px; width: 20px; height: 20px;" src="@/assets/common/icon-common-copy.png"
                alt="" class="mouse-pointer" @click="handleCopyLandingUrl">
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 系统机构不显示下载协议 -->
      <el-row v-if="mode == 'details' && baseInfoDO.institution.type == 3" style="margin:0 10px" :gutter="50" 
        type="flex" justify="space-between">
        <el-col :span="8" style="text-align: left">
          <el-form-item style="width: 100%; color: #3A7FF3;" :label="title + '入驻协议：'">
            <div class="div-download mouse-pointer" @click="handleDownload">
              <span>点击下载</span>
              <img style="margin-left: 6px; width: 18px; height: 23px;" 
                src="@/assets/instmng/instlist/img-instmng-download.png" alt="">
            </div>
          </el-form-item>
        </el-col>
				<el-col :span="16" style="text-align: left">
          <el-form-item style="width: 100%" label="机构主页地址（支持嵌入机构微信公众号中）：">
            <div style="display: flex; align-items: center;">
              <span>{{baseInfoDO.institutionMainPageUrl}}</span>
              <img style="margin-left: 15px; width: 20px; height: 20px;" src="@/assets/common/icon-common-copy.png" 
                alt="" class="mouse-pointer" @click="handleCopyMainPageUrl">
            </div>
          </el-form-item>
        </el-col>
      </el-row>
		</el-form>
    <div class="bk-wizard-bottons" style="padding: 10px 25px 30px 0px;">
      <wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>

<script>
import instStore from './InstStore.js'
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'

let InstBaseInfoPanel = {
  name: 'InstBaseInfoPanel',
  instStore,

  data() {
    let validatePic = (_rule, _value, callback) => {
			if (!this.picPath || this.picPath == require('@/assets/common/img-common-chooseimg.png')) {
				callback(new Error('请上传营业执照'));
			} else {
				callback();
			}
    };

    let validateRemark = (_rule, _value, callback) => {
			if (this.baseInfoDO.institution.remark && this.baseInfoDO.institution.remark.trim().length == 0) {
				callback(new Error('服务说明不能全输入空格或者换行等空白字符'));
			} else {
				callback();
			}
    };

    let validateBrandingImgs = (_rule, _value, callback) => {
      let errorImgs = this.brandingImgs.filter(item => {
        return item.errorText && item.errorText.length
      });
      if (!errorImgs || errorImgs.length == 0) {
       callback();
      }
    };

    let validateIntroduction = (_rule, _value, callback) => {
			if (this.baseInfoDO.institution.introduction && this.baseInfoDO.institution.introduction.trim().length == 0) {
				callback(new Error('简介不能全输入空格或者换行等空白字符'));
			} else {
				callback();
			}
    };

    return {
      btnStatus: {'prev': false, 'next': true, 'submit': false},      
      rules: {
        province: [{required: true, message: '请选择所属省', trigger: 'blur'}],
        city: [{required: true, message: '请选择所属市', trigger: 'blur'}],
        county: [{required: true, message: '请选择所属县', trigger: 'blur'}],
        addr: [{required: true, message: '请输入机构地址', trigger: 'blur'},
               {max:100,message: '输入地址字数最多为100',} ],
        name: [{required: true, message: '请输入机构名称', trigger: 'blur'},
               {min:3,max: 32,message: '输入机构名称字数应在3-32之间',},],
				identifier: [{required: true, message: '请输入机构编号', trigger: 'blur'},
                     {min:2,max: 20,message: '输入机构编号字数在2-20之间',},],
				deposit: [{required: true, message: '请输入保证金金额', trigger: 'blur'},],
				bizLicense: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'},],
				legalPerson: [{required: true, message: '请输入法人代表姓名', trigger: 'blur'},],
        contact: [{required: true, message: '请输入联系人姓名', trigger: 'blur'},],
				contactNum:[{required: true, message: '请输入联系人电话', trigger: 'blur'},],
				csr: [{required: true, message: '请输入客服姓名', trigger: 'blur'},],
				csTeleno: [{required: true, message: '请输入客服电话', trigger: 'blur'},],
        picPath: [{required: true, validator: validatePic, trigger: 'blur'},],
        remark: [{required: false, validator: validateRemark, trigger: 'blur'},],
        introduction: [{required: false, validator: validateIntroduction, trigger: 'blur'},],
        brandingImgs: [{required: false, validator: validateBrandingImgs, trigger: 'blur'},],
      },
      provinceList: [],
			cityList: [],
			countyList: [],
      maxBrandingImgsCount: 10,
      title: '星护云'
    }
  },

  computed: {
    mode() {
      return instStore.state.mode;
    },

    baseInfoDO() {
      if (Object.keys(instStore.state.baseInfoDO.institution).length == 0) this.clearVaild();
      return instStore.state.baseInfoDO;
    },

    readonly() {
      return instStore.state.mode == 'details';
    },

    srcProvinceList() {
      this.provinceList = instStore.state.srcProvinceList;
      return instStore.state.srcProvinceList;
    },

    srcCityList() {
      this.cityList = instStore.state.srcCityList;
      return instStore.state.srcCityList;
    },

    srcCountyList() {
      this.countyList = instStore.state.srcCountyList;
      return instStore.state.srcCountyList;
    },

    logoPath() {
      if (instStore.state.logoFile) {
        return this.commonUtil.file2Url(instStore.state.logoFile);
      }
      return this.baseInfoDO.institution.logoPath 
        ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoDO.institution.logoPath)
        : require('@/assets/common/img-common-chooseimg.png');
    },

    logoFile() {
      return instStore.state.logoFile?instStore.state.logoFile:null;
    },

    picPath() {
      if (instStore.state.picFile) {
        return this.commonUtil.file2Url(instStore.state.picFile);
      }
      return this.baseInfoDO.institution.licensePath 
        ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoDO.institution.licensePath)
        : require('@/assets/common/img-common-chooseimg.png');
    },

    picFile() {
      return instStore.state.picFile ? instStore.state.picFile : null;
    },

    brandingFiles() {
      return instStore.state.brandingFiles && instStore.state.brandingFiles.length ? instStore.state.brandingFiles 
        : [];
    },

    brandingImgs() {
      if (!instStore.state.brandingFiles || instStore.state.brandingFiles.length == 0) {
        return [];
      }
      let imgs = [];
      instStore.state.brandingFiles.forEach((item, index) => {
        if (item) {
          if (typeof item == 'object') {
            imgs.push({img: this.commonUtil.file2Url(item.file), errorText: item.errorText, index: index});
          } else {
            imgs.push({img: this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, item), errorText: '', index: index});
          }
        }
      })
      return imgs;
    },

    previewImgList() {
      let imgList = [];
      if (this.baseInfoDO.institution.logoPath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoDO.institution.logoPath));
      }
      if (this.baseInfoDO.institution.licensePath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfoDO.institution.licensePath));
      }
      if (this.baseInfoDO.institution.aboutUsPathLists && this.baseInfoDO.institution.aboutUsPathLists.length) {
        this.baseInfoDO.institution.aboutUsPathLists.forEach((item, _index) => {
          imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, item));
        })
      }
      return imgList;
    }
  },

  methods: {
		//选择省
    handleProvinceChange(value) {
      this.baseInfoDO.institution.provinceId = Util.searchKeyWithValueInArr('name', value, this.provinceList).id;
      this.baseInfoDO.institution.city = "";
      this.baseInfoDO.institution.cityId = "";
      this.baseInfoDO.institution.county = "";
      this.baseInfoDO.institution.countyId = "";
      this.requsetCityList(this.baseInfoDO.institution.provinceId);
    },

    //请求市数据
    requsetCityList(id) {
      let url = this.commonUtil.fillUrlArgments(this.commonUrl.URL_LIST_COMMON_CITY, id);
      this.appAxios("GET", url).then(result => {
        if (result != null) {
          instStore.commit('changeSrcCityList', result.data);
        }
      });
    },

    //选择市
    handleCityChange(value) {
      this.baseInfoDO.institution.cityId = Util.searchKeyWithValueInArr('name', value, this.cityList).id;
      this.baseInfoDO.institution.county = "";
      this.baseInfoDO.institution.countyId = "";
      this.requsetCountyList(this.baseInfoDO.institution.cityId);
    },

    //请求县数据
    requsetCountyList(id) {
      let url = this.commonUtil.fillUrlArgments(this.commonUrl.URL_LIST_COMMON_COUNTY, id);
      this.appAxios("GET", url).then(result => {
        if (result != null) {
          instStore.commit('changeSrcCountyList', result.data);
        }
      });
    },

    //选择县
    handleCountyChange(value) {
      this.baseInfoDO.institution.countyId = Util.searchKeyWithValueInArr('name', value, this.countyList).id;
    },

		//输入保证金
		inputDeposit() {
			//只能输入数字，最长10位
			this.baseInfoDO.institution.deposit = 
        this.commonUtil.filterDigitals(this.baseInfoDO.institution.deposit, ['.']);
			if (this.baseInfoDO.institution.deposit.length > 10) {
				this.baseInfoDO.institution.deposit = this.baseInfoDO.institution.deposit.slice(0, 10);
			}
		},

    //输入机构名称
    inputInstitutionName() {
      this.baseInfoDO.institution.name = this.handleInstName(this.baseInfoDO.institution.name,true);
      if (this.baseInfoDO.institution.name.length > 32) {
				this.baseInfoDO.institution.name = this.baseInfoDO.institution.name.slice(0, 32);
			}
      let name = this.handleInstName(this.baseInfoDO.institution.name, false);
			this.baseInfoDO.institution.identifier = this.pinyin.getCamelChars(name);
      this.baseInfoDO.institution.identifier = this.handleZQToCQ(this.baseInfoDO.institution.name, this.baseInfoDO.institution.identifier);
    },

    //输入机构编号
    inputInstitutionIdentify() {
      this.baseInfoDO.institution.identifier = this.handleInstIdentifier(this.baseInfoDO.institution.identifier);
      if (this.baseInfoDO.institution.identifier.length > 20) {
				this.baseInfoDO.institution.identifier = this.baseInfoDO.institution.identifier.slice(0, 20);
			}
    },

    handleInstName(str, containBrackets) {
      // 机构名称只能输入汉字、数字、中文英文的括号
      return Util.filterChineseAndDigitalsAndBrackets(str, containBrackets);
    },

    //特殊处理机构名称带有重庆转换后是ZQ的问题
    handleZQToCQ(name, identify) {
      return Util.changeIdentifyOfZQToCQ(name, identify);
    },

    handleInstIdentifier(str) {
      // 机构标识只能输入字母和数字
      return this.commonUtil.filterDigitalsAndLetters(str);
    },

		//输入客服手机号
		inputCsTeleno() {
			this.baseInfoDO.institution.csTeleno = 
        this.commonUtil.filterDigitals(this.baseInfoDO.institution.csTeleno, ['-']);
		},

    //输入联系人电话
    inputContactNum() {
      this.baseInfoDO.institution.contactNum = 
        this.commonUtil.filterDigitals(this.baseInfoDO.institution.contactNum, ['-']);
    },

		//选择logo改变
    handleInstLogoChange(file, _fileList) {
      let instLogoLimitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 100.0,
        maxHeight: 0,
        extLimit: {
          limitType: 1,
          minRatio: 0.4,
          minRatioText: '100:40',
          maxRatio: 1.5,
          maxRatioText: '100:150'
        },
        returnData: {}
      };
      this.imgUtil.validateAndCompressImg(file, instLogoLimitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          instStore.commit('changeLogoFile', data.file);
        }
      })
    },

		//选择营业执照改变
    handlePicChange(file, _fileList) {
      let instLicenselimitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 600.0,
        maxHeight: 0,
        extLimit: {
          limitType: 2,
          minRatio: 0.1,
          minRatioText: '100:10',
        },
        returnData: {}
      };
      this.imgUtil.validateAndCompressImg(file, instLicenselimitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          instStore.commit('changePicFile', data.file);
        }
        this.$refs.baseInfoForm.validateField('picPath');
      })
    },

    //新增品牌宣传图
    handleAddBrands(file, fileList) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 600.0,
        maxHeight: 0,
        extLimit: {
          limitType: 2,
          minRatio: 0.1,
          minRatioText: '100:10',
        },
        returnData: {
          index: fileList.length - 1
        }
      };
      this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        let result = (instStore.state.brandingFiles && instStore.state.brandingFiles.length) 
          ? instStore.state.brandingFiles : [];
        if (this.brandingImgs.length < this.maxBrandingImgsCount) {
          result.push({file: data.file, errorText: data.errorText, index: data.returnData.index});
          //注意这里由于validateAndCompressImg是异步的会导致push进去的顺序和新增顺序不一致，因此需要按对象的index重新排序
          result = this.commonUtil.sortObjectArrayByKey(result, 'index');
          instStore.commit('changeBrandingFiles', result);
        }
      })
    },

    handleBrandChange(index, file, _fileList) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 600.0,
        maxHeight: 0,
        extLimit: {
          limitType: 2,
          minRatio: 0.1,
          minRatioText: '100:10',
        },
        returnData: {
          index: index
        }
      };
      this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        let result = instStore.state.brandingFiles && instStore.state.brandingFiles.length 
          ? instStore.state.brandingFiles : [];
        result.splice(index, 1, {file: data.file, errorText: data.errorText, index: data.returnData.index});
        //注意这里由于validateAndCompressImg是异步的会导致push进去的顺序和新增顺序不一致，因此需要按对象的index重新排序
        result = this.commonUtil.sortObjectArrayByKey(result, 'index');
        instStore.commit('changeBrandingFiles', result);
      })
    },

    handleDeleteBrand(index) {
      let result = instStore.state.brandingFiles && instStore.state.brandingFiles.length 
        ? instStore.state.brandingFiles : [];
      //将当前下标往后的对象index-1
      result.forEach((item) => {
        if (item.index > index) {
          item.index = item.index - 1; 
        }
      });
      result.splice(index, 1);
      result = this.commonUtil.sortObjectArrayByKey(result, 'index');
      instStore.commit('changeBrandingFiles',result);
    },

    handleAdminItemClick(amninId, subType) {
      this.$router.push({name: 'bkuser', params: {adminId: amninId, type: 'instDetails', subType: subType}})
    },

    handleCopyLandingUrl() {
      this.commonUtil.copyTextToBoard(this, this.baseInfoDO.landingUrl);
    },

    handleCopyMainPageUrl() {
      this.commonUtil.copyTextToBoard(this, this.baseInfoDO.institutionMainPageUrl);
    },

    handleDownload() {
      let params = {id: this.baseInfoDO.institution.id};
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_DOWNLOAD_CONTRACT,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          let u8arr = this.decodeBase64PDFData(result.data);
          let blob = new Blob([u8arr],{type: "application/pdf"});//用blob生成pdf文件,返回PDF文件
          let fileName =  this.title + '入驻协议' + result.time + '.pdf';
          this.downloadExportFile(blob, fileName);
        }
      })
    },

    decodeBase64PDFData(result) {
      let decode = window.atob(result);
      let u8arr = new Uint8Array(decode.length);
      for (let i = 0; i < decode.length; i++) {
        u8arr[i] = decode.charCodeAt(i);
      }
      return u8arr;
    },

    downloadExportFile(blob, fileName) {
      let downloadElement = document.createElement('a')
      if (typeof blob == 'string') {
        this.$message.error('当前下载' + this.title + '入驻协议文件流类型错误');
        return;
      }
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = fileName;//下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click() //点击下载
      document.body.removeChild(downloadElement) //下载完成移除元素
      if (typeof blob != 'string') {
        window.URL.revokeObjectURL(href) //释放掉blob对象
      }
    },

		handleBtnSelection(opr) {
			if (this.mode == 'details' || opr != 'next')  {
					this.$emit("panel-operate", opr);
					return true;
			}
			this.$refs.baseInfoForm.validate((valid) => {
				if (!valid) return false;
				else {
          this.$emit("panel-operate", opr);
					return true;
				}
			});
		},

    clearVaild() {
    	this.$nextTick(() => {
        this.$refs["baseInfoForm"].clearValidate();
      });
		},
  },

  mounted() {
    this.$nextTick(() => {
      if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') {
        this.title = '悠心陪护';
      } else {
        this.title = '星护云';
      }
    });
  },

  destroyed() {
    //销毁的时候同步数据
    instStore.commit('changeBaseInfoDO', this.baseInfoDO);
  },
}
export default InstBaseInfoPanel
</script>

<style scoped>
.inst-baseinfo-panel-main {
	margin: 20px 0 0 0;
}
.baseInfoForm {
  margin-bottom: 60px;
}
.logo-uploader {
	background-color: #EBEEF2;
	width: 64px;
	height: 64px;
	text-align: center;
}
.homepage-uploader {
	background-color: #EBEEF2;
	width: 100%;
	height: 162px;
	text-align: center;
}
.img-logo { 
	width: 64px;
	height: 18px; 
	margin-top: 13px;
}
.img-homepage { 
	width: 64px;
	height: 26px; 
	margin-top: 53px;
}
.img-logo-file {
  height: 64px;
  margin: 0px;
}
.img-homepage-file {
  height: 162px;
  margin: 0px;
}
.el-upload:hover .text-logo-hover {
  display: block; 
}
.text-logo-hover {
  display: none;
  font-size: 8px;
  text-align: center;
  z-index: 200;
  position: absolute;
  top: 0px;
  left: 0px;
  width:64px;
  height: 64px;
  line-height: 64px;
  background: rgba(124,124,124,0.5500);
  font-weight: 600;
  color: #FFFFFF;
}
.tip-logo {
  text-align: left;
  margin-left: 7px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
}
.tip-licensePath {
  margin-top: 11px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
}
.div-download {
  display: flex;
  align-items: center;
}
.bk-has-logo {
  width:64px;
  height:64px;
  background-color:#EBEEF2;
  display:flex;
  justify-content:center;
  align-items:center;
}
.bk-has-license {
  width: 100%;
  height:162px;
  background-color:#EBEEF2;
  display:flex;
  justify-content:center;
  align-items:center;
}
.bk-details-branding-imgs,.bk-upload-branding-imgs {
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.branding-img-item {
  width: calc((100% - 224px)/3);
  margin-bottom: 20px;
  position: relative;
}
.branding-img-item-space {
  margin-right: 112px;
}
.branding-uploader {
  background-color: #EBEEF2;
	width: 100%;
	height: 170px;
	text-align: center;
}
.img-brandingpage { 
	width: 64px;
	height: 26px; 
	margin-top: 53px;
}
.bk-upload-branding .tip {
  margin-top: 10px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
}
.tip-red {
  color: #FF1515;
}
.upload-branding-hover {
  display: none;
  text-align: center;
  z-index: 200;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 170px;
  line-height: 170px;
  background: rgba(124,124,124,0.5500);
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
}
.bk-delete {
  display: none;
  text-align: center;
  z-index: 201;
  position: absolute;
  top: -11px;
  right: -11px;
  width: 22px;
  height: 22px;
}
.bk-delete img {
  width: 100%;
  height: 100%;
}
.bk-remark, .bk-introduce {
  width: 100%;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
.bk-remark .word-count, .bk-introduce .word-count {
  font-size: 14px;
  color: #909090;
  line-height: 20px;
  padding: 0 15px 2px 15px;
  text-align: right;
}
.el-upload:hover .upload-branding-hover, .el-upload:hover .bk-delete {
  display: block; 
}
.div-branding-error {
  text-align: center;
  margin-top: 10px;
  font-size: 12px;
  color: #FF4F4F;
  line-height: 12px;
}
</style>
<style>
.inst-baseinfo-panel-main .el-form--label-top .el-form-item__label {
	padding: 0px;
  line-height: 26px;
}
.inst-baseinfo-panel-main .branding-img-item .el-upload,
.homepage-uploader .el-upload,
.inst-baseinfo-panel-main .logo-uploader .el-upload {
  width: 100%;
  height: 100%;
}
.inst-baseinfo-panel-main .bk-remark .el-textarea__inner,
.inst-baseinfo-panel-main .bk-introduce .el-textarea__inner {
  border: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/institutiondetails/InstBaseInfoPanel.vue